import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { mapApiKey } from "../../Utils";
import { useRef } from "react";
import Autocomplete from "react-google-autocomplete";
import { AddLeadReducer } from "../../features/slice";
import { toast } from "react-toastify";
import Loader from "../Loader";

function AddLead(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [countryData, setCountryData] = useState();
  const [loading, setLoading] = useState(false);
  const autocompleteRef = useRef();

  const initialValues = {
    area: "",
    userName: "",
    address: "",
    long: "",
    lat: "",
    email: "",
    countryCode: "",
    mobile: "",
    propertyName: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      userName: Yup.string().required("Required"),
      area: Yup.string().required("Required"),
      address: Yup.string().required("Required"),
      email: Yup.string().required("Required"),
      mobile: Yup.string().required("Required"),
      propertyName: Yup.string().required("Required"),
    }),
    enableReinitialize: true,
    onSubmit: (values, { isSubmitting, resetForm }) => {
      setLoading(true);

      const payload = {
        userName: values.userName,
        email: values.email,
        countryCode: values.countryCode,
        phoneNumber: values.mobile,
        propertyName: values.propertyName,
        location: values.address,
        area: values.area,
      };

      dispatch(AddLeadReducer(payload)).then((data) => {
        setLoading(false);
        if (data?.payload?.code === 1) {
          toast.success(data.payload.message);
          props.handleShow();
        } else {
          setLoading(false);
          toast.error(data.payload.message);
        }
      });
    },
  });

  return (
    <>
      {" "}
      <Modal show={props.show} onHide={props.handleShow} centered size="md">
        <Modal.Body>
          <div className="position-relative mb-4">
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                props.handleShow();
              }}
            ></button>
            <h4 className="text-center mb-1">Lead</h4>

            <form className="form-style mt-5" onSubmit={formik.handleSubmit}>
              <div className="row">
                <div className="col-sm-12 col-md-12 mb-3">
                  <div className="form-group">
                    <div className="input-container">
                      <input
                        type="text"
                        className="form-control"
                        value={formik.values.userName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="userName"
                        placeholder="Name"
                      />
                      <img
                        src="assets/images/user.png"
                        className="input-img"
                        alt=""
                      />
                    </div>
                    {formik.errors.userName && formik.touched.userName && (
                      <div className="text-red"> {formik.errors.userName}</div>
                    )}
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 mb-3">
                  <div className="form-group">
                    <div className="input-container">
                      <input
                        type="email"
                        className="form-control"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="email"
                        placeholder="Email Address"
                      />
                      <img
                        src="assets/images/email.png"
                        className="input-img"
                        alt=""
                      />
                    </div>
                    {formik.errors.email && formik.touched.email && (
                      <div className="text-red"> {formik.errors.email}</div>
                    )}
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 mb-4">
                  <div className="form-group">
                    <div className="input-container">
                      <PhoneInput
                        country="in"
                        inputProps={{
                          name: "mobile",
                        }}
                        enableSearch
                        value={formik.values.countryCode + formik.values.mobile}
                        onChange={(phone, country, e, formattedValue) => {
                          setCountryData({ formattedValue, country });
                          if (phone.length > 0) {
                            const raw = phone.slice(country?.dialCode?.length);
                            formik.setFieldValue("mobile", raw);

                            formik.setFieldValue(
                              "countryCode",
                              formattedValue?.split(" ")[0]
                            );
                          } else {
                            formik.setFieldValue("mobile", "");

                            formik.setFieldValue("countryCode", "");
                          }
                        }}
                        onBlur={formik.handleBlur}
                        placeholder="Enter Phone Number"
                        containerclassName="form-control signupClass"
                        inputclassName="phoneInputClass"
                      />
                      <img
                        src="assets/images/phone.png"
                        className="input-img"
                        alt=""
                      />
                    </div>
                    {formik.errors.mobile && formik.touched.mobile && (
                      <div className="text-red"> {formik.errors.mobile}</div>
                    )}
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 mb-3">
                  <div className="form-group">
                    <div className="input-container">
                      <Autocomplete
                        apiKey={mapApiKey}
                        name="address"
                        className="form-control"
                        placeholder="Location"
                        value={formik.values.address}
                        ref={autocompleteRef}
                        onChange={() => {
                          // console.log(autocompleteRef);
                          formik.setFieldValue(
                            `address`,
                            autocompleteRef.current.value
                          );
                        }}
                        onPlaceSelected={(place, inputRef, autocompleteRef) => {
                          // console.log(place, inputRef, autocompleteRef);
                          if (place) {
                            let lat = place.geometry.location.lat();
                            let lng = place.geometry.location.lng();
                            let address = place.formatted_address;
                            formik.setFieldValue(`address`, address);
                            formik.setFieldValue(`long`, lng);
                            formik.setFieldValue(`lat`, lat);
                          }
                        }}
                        options={{
                          types: ["(regions)"],
                          componentRestrictions: { country: "in" },
                        }}
                      />
                      <img
                        src="assets/images/Location.png"
                        className="input-img"
                        alt=""
                      />
                    </div>
                    {formik.errors.address && formik.touched.address && (
                      <div className="text-red"> {formik.errors.address}</div>
                    )}
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 mb-3">
                  <div className="form-group">
                    <div className="input-container">
                      <input
                        type="text"
                        className="form-control"
                        value={formik.values.propertyName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="propertyName"
                        placeholder="Enter Property Name"
                      />

                      <img
                        src="assets/images/Property.png"
                        className="input-img"
                        alt=""
                      />
                    </div>
                    {formik.errors.propertyName &&
                      formik.touched.propertyName && (
                        <div className="text-red">
                          {" "}
                          {formik.errors.propertyName}
                        </div>
                      )}
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 mb-3">
                  <div className="form-group">
                    <div className="input-container">
                      <input
                        type="text"
                        className="form-control"
                        value={formik.values.area}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="area"
                        placeholder="Total Built -up Area"
                      />
                      <img
                        src="assets/images/Area.png"
                        className="input-img"
                        alt=""
                      />
                      <span className="inputImgRight">Sqft</span>
                    </div>
                    {formik.errors.area && formik.touched.area && (
                      <div className="text-red"> {formik.errors.area}</div>
                    )}
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 text-center">
                  <button type="submit" className="btn btn-save w-50">
                    {loading ? <Loader /> : "Submit"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AddLead;
